import {faChevronDown, faCog, faInfo, faTrash, faUserClock} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';

import {mainState} from '../../AppMainState';
import {Button} from '../../components/Button';
import {Card} from '../../components/Card';
import {FormInput} from '../../components/form/FormInput';
import {UserStatus} from '../../swagger';
import {SettingsViewState} from './SettingsViewState';
import {createLogLink, editLogLink, integrationInstructionsLink, projectDashboardLink} from '../../routing/AppRoutes';

export const SettingsView: FC = observer(() => {
    const {projectId} = useParams();

    const [state] = useState(() => new SettingsViewState());

    useEffect(() => {
        state.setProject(projectId);
    }, [projectId]);

    return <section className="">
        <h1 className="font-bold font-roboto-bold mb-4 text-3xl">

            {mainState.projects?.length ?? -1 > 0 ? 'Projects' : 'Your project list is empty'}
        </h1>
        {mainState.projects.filter((x) => x.userId === mainState.currentUser!.userId)
            .map((p) => {
                return <Card
                    className="mb-4"
                    to={projectDashboardLink(p.projectId!)}
                    title={p.name}
                    cardControls={
                        state?.currentProjectId === p.projectId && !mainState.isDemoUser ? (
                            <button
                                className="btn btn-link btn-sm text-m-brand-red focus:outline-none"
                                onClick={() => state?.deleteProject(p.projectId!)}
                                title="Delete project & it's logs"
                            >
                                <FontAwesomeIcon className="mr-4" icon={faTrash} />
                                <span className="hidden sm:inline">Delete project & it's logs</span>
                            </button>
                        ) : (
                            <button
                                className="btn btn-sm text-right focus:outline-none md:w-1/2"
                                onClick={() => state?.setCurrentProjectId(p.projectId)}
                            >
                                <span className="hidden sm:inline">Expand project</span>
                                <FontAwesomeIcon className="ml-4" icon={faChevronDown}/>
                            </button>
                        )
                    }
                    key={'projectid' + p.projectId}
                >
                    <div
                        className={
                            'grid grid-cols-1 lg:grid-cols-2 gap-12 ' +
                            (state?.currentProjectId === p.projectId ? '' : 'hidden')
                        }
                    >
                        <div className="col-span-1">
                            <h3 className="font-medium font-roboto-medium mb-3 text-xl">
                                {p.logs && p.logs.length > 0
                                    ? 'Active logs list'
                                    : 'No logs in current project'}
                            </h3>
                            {/* eslint-disable-next-line no-irregular-whitespace */}
                            {/* tu będzie trochę inaczej niż na projekcie, ma być tylko nazwa logu i ikona koszyka oraz ikona ustawień*/}

                            <ul className="bg-m-gray-2 list-disc list-inside mb-4 px-4 py-2 rounded-md">
                                {p.logs?.map((l) => {
                                    return (
                                        <li className="flex flex-wrap items-center" key={'logid' + l.logId}>

                                                    <span className="">
                                                        <span className="list-item-bullet mr-4"/>
                                                        {l.name}
                                                    </span>
                                            <span className="flex-grow"/>
                                            <span className="inline-flex">
                                                        <Link
                                                            className="btn btn-link btn-sm"
                                                            to={integrationInstructionsLink(l.logId!)}
                                                            title={'Integration instructions'}
                                                        >
                                                            <FontAwesomeIcon
                                                                className="fill-current text-m-gray-6 mr-1"
                                                                icon={faInfo}
                                                            />
                                                            Integration
                                                        </Link>
                                                        <Link
                                                            className="btn btn-link btn-sm"
                                                            to={editLogLink(l.logId!)}
                                                            title={'Edit log'}
                                                        >
                                                            <FontAwesomeIcon
                                                                className="fill-current text-m-gray-6 mr-1"
                                                                icon={faCog}
                                                            />
                                                            Edit
                                                        </Link>
                                                {!mainState.isDemoUser && <button
                                                    className="btn btn-sm ml-2 mr-2"
                                                    onClick={() => state?.deleteLog(l.logId!)}
                                                    title="Delete log"
                                                >
                                                    <FontAwesomeIcon
                                                        className="fill-current text-m-brand-red  mr-1"
                                                        icon={faTrash}
                                                    />
                                                    Delete log
                                                </button>}
                                                    </span>
                                        </li>
                                    );
                                })}
                            </ul>
                            <Button className="btn btn-primary w-full md:w-auto">
                                <Link to={createLogLink(p.projectId!)}>Add new log</Link>
                            </Button>
                        </div>

                        <div className="col-span-1">
                            <h3 className="font-medium font-roboto-medium mb-3 text-xl">Users</h3>
                            <ul className="bg-m-gray-2 mb-4 px-4 py-2 rounded-md">
                                {p.users
                                    ?.filter((x) => x.name !== mainState.currentUser?.email)
                                    .map((u) => {
                                        /*na tej liście są też tylko emaile*/
                                        return (
                                            <li className="flex items-center" key={'userId' + u.name}>
                                                <span className="list-item-bullet mr-4"></span>
                                                <span className="truncate">
                                                            {u.name}
                                                        </span>

                                                {u.status === UserStatus.Active && (
                                                    <button
                                                        className="btn btn-sm ml-auto"
                                                        onClick={() =>
                                                            state?.deleteUser(p.projectId!, u.userId!)
                                                        }
                                                        title={'Remove user'}
                                                    >
                                                        <FontAwesomeIcon
                                                            className="fill-current text-m-brand-red"
                                                            icon={faTrash}
                                                        />
                                                    </button>
                                                )}

                                                {(u.status === UserStatus.Pending || u.status === UserStatus.EmailNotConfirmed) && (
                                                    <span className="fill-current ml-auto">
                                                                {u.status === UserStatus.Pending &&
                                                                    <span className="text-m-gray-6 text-sm">Waiting for registration </span>}
                                                        {u.status === UserStatus.EmailNotConfirmed &&
                                                            <span className="text-m-gray-6 text-sm">Email not confirmed. User needs to check mailbox and confirm email</span>}
                                                        <FontAwesomeIcon
                                                            className="text-m-gray-6 mr-1 ml-2"
                                                            icon={faUserClock}
                                                        /></span>
                                                )}
                                            </li>
                                        );
                                    })}
                            </ul>
                            {!state?.showUserForm && (
                                <Button
                                    className="btn btn-primary w-full md:w-auto"
                                    onClick={() => state?.showAddUserForm()}
                                >
                                    Add new user
                                </Button>
                            )}

                            {state?.showUserForm && (
                                <div>
                                    <FormInput
                                        id={'adduser' + p.projectId}
                                        label={'Email'}
                                        name="email"
                                        onChange={(v) => state?.setUserEmail(v)}
                                        required
                                        value={state.userEmail}
                                    />
                                    <Button
                                        className="btn btn-primary"
                                        onClick={() => state?.saveUser(p.projectId!, state.userEmail)}
                                    >
                                        Save
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </Card>;
            })}
    </section>;
});
